
import Vue from 'vue';
import { Data as Tag } from '@root/modules/tags/types/tag';
import ContentImage from '@core/components/UI/ContentImage.vue';

type Overrides = {
  slug: string;
  layout: string;
  description: string;
};

interface Props {
  tag: Tag;
}

interface Computed {
  overrides: Overrides | undefined;
  description: string | boolean;
  imageId: string | null;
}

export default Vue.extend<unknown, Computed, unknown, Props>({
  components: {
    ContentImage,
  },
  props: {
    tag: {
      type: Object,
    },
  },
  computed: {
    overrides() {
      const { component } = this.$channelConfig('page').tags;

      return component?.overrides && component?.overrides.find((p) => p.slug === this.$route.params.slug);
    },
    description() {
      return (this.overrides && this.overrides.description) || this.$props.tag.descriptionContent?.html || false;
    },
    imageId() {
      return this.tag.image?.length ? this.tag.image[0].value?.id : null;
    },
  },
});
